<template>
  <div :class="mark">
    <home-page
      v-if="isNewMode"
      :isPre="preview"
      :shopList="shopList"
      @refresh="refresh"
      :yl_mark_id="yl_mark_id"
      :storeInfo="storeInfo"
      @showEnterprise="showEnterprise"
      :b_money="b_money"
      @goPathUrl="goPathUrl"
      :is_show_retail_price="is_show_retail_price"
      :newMarkInfo="newMarkInfo"
      @sortChange="handleSortChange"

    ></home-page>

    <div v-else>
      <div class="home">
        <!-- 头部-->
        <div class="home_top">
          <img :src="ossImgPathIndex + 'bg_top_img.png'" alt class="topbg" />
          <div class="home_title flex_b">
            <div class="flex title" @click="showEnterprise">
              <img :src="storeInfo.store_logo" alt />
              <img
                class="B_renzheng"
                v-if="is_showrenzheng == 200"
                :src="StoreCompanyInfo.img_url"
              />
              <div class="name">{{ storeInfo.store_name }}</div>
            </div>
            <div class="search" @click="() => goPathUrl('/search')">
              <iconfont
                name="iconsousuo"
                class="icon"
                size="0.56rem"
                color="#fff"
              ></iconfont>
            </div>
          </div>
          <div class="home_swiper">
            <van-swipe
              class="my-swipe"
              :autoplay="3000"
              indicator-color="white"
            >
              <van-swipe-item
                v-for="(item, index) in swipeList"
                @click="() => pathSwiper(index)"
                :key="index"
              >
                <img :src="item.img_url" alt class="topbg" />
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <!--  icon 入口-->
        <div class="table_swiper">
          <van-swipe class="my-swipe">
            <van-swipe-item>
              <div class="nut-swiper-slide">
                <div class="flex_a tablist">
                  <div @click="() => goPathUrl('/order?type=0', true)">
                    <img :src="ossImgPathIndex + 'tabList0.png'" alt />
                    <div>我的订单</div>
                  </div>
                  <div
                    @click="() => goPathUrl('/record?b_money=' + b_money, true)"
                  >
                    <img :src="ossImgPathIndex + 'tabList1.png'" alt />
                    <div>我的积分</div>
                  </div>
                  <div
                    @click="() => goPathUrl('/collecExchange?state=2', true)"
                  >
                    <img :src="ossImgPathIndex + 'tabList2.png'" alt />
                    <div>我的收藏</div>
                  </div>
                  <div class="pr" @click="goPhoneStore">
                    <img :src="ossImgPathIndex + 'tabList3.png'" alt />
                    <div>联系商家</div>
                    <a
                      class="phone_tel_x"
                      v-if="this.storeInfo.is_custorm_count == 1"
                      :href="
                        demoShow ? 'javascript:;' : 'tel:' + storeInfo.phone_mob
                      "
                    ></a>
                  </div>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item v-if="moduleList.length > 0">
              <div class="nut-swiper-slide">
                <div class="flex_a tablist">
                  <div
                    v-for="(item, index) in 4"
                    :key="index"
                    @click="() => goPathUrl(moduleList[index].url, 'web')"
                  >
                    <img
                      :src="moduleList[index] ? moduleList[index].img : ''"
                      alt
                    />
                    <div>
                      {{ moduleList[index] ? moduleList[index].title : "" }}
                    </div>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>

        <!-- 我的积分 -->
        <div class="my_scores bg color">
          <iconfont
            name="iconjifen01"
            size="0.65rem"
            :color="markColor"
          ></iconfont>
          <p class="title borderColor">我的积分</p>
          <p class="init">{{ b_money || 0 }}</p>
          <span @click="showJiFen">
            <iconfont
              name="iconiconfontquestion"
              size="0.6rem"
              :color="markColor"
            ></iconfont
            >怎么赚积分
          </span>
        </div>

        <!-- 精选推荐 -->
        <div class="recommend">
          <img :src="ossImgPathIndex + 'boutique.png'" alt class="com_bg_img" />
          <div class="recommend_title color">
            <img :src="ossImgPath + 'fuliizii.png'" alt class="fl" />
            <p
              class="fr box-shadow"
              @click="() => goPathUrl('/collecExchange')"
            >
              我能兑换
              <iconfont
                name="iconnavigate-right"
                size="0.4rem"
                :color="markColor"
              ></iconfont>
            </p>
          </div>
          <div class="recommend_list">
            <div
              v-for="(item, index) in fourShopData"
              :key="index"
              @click="() => goPathUrl('/shopDetail?id=' + item.stock_id)"
            >
              <img :src="item.goods_image" alt />
              <div>{{ item.jinbi }}分</div>
            </div>
          </div>
        </div>

        <!-- 跳转列表 -->
        <!-- 开通 -->
        <!-- <div class="flex_b path_list">
        
        <img @click="(e) => goWebPath(pathList.shop_url)" :src="
            pathList.is_shop == 1
              ? ossImgPath + 'xiaoidniaSel.png'
              : ossImgPath + 'xiaoidnia.png'
          " alt />
        <img @click="(e) => goWebPath(pathList.bp_url)" :src="
            pathList.is_bp == 1
              ? ossImgPath + 'jifennisSel.png'
              : ossImgPath + 'jifennis.png'
          " alt />
        <img @click="(e) => goWebPath(1)" :src="
            pathList.is_bylm == 1
              ? ossImgPath + 'sheuqlnaSel.png'
              : ossImgPath + 'sheuqlna.png'
          " alt />
      </div>-->
      </div>

      <!-- 列表 -->
      <div class="redemption_list">
        <div class="redemption_tab flex_a">
          <!--提示-->
          <div
            class="nav_tips l_left flex_a"
            :class="titleList.length == 1 ? 'l_left_no_right' : ''"
            v-if="isTabTipsLe && titleKey == 1"
          >
            <span>商城兑换，兑换完成请耐心等待快递邮寄</span>
            <Iconfont
              name="iconx"
              class="icon"
              size="0.6rem"
              color="#FD3E3E"
              @click="() => closeTip('isTabTipsLe')"
            />
          </div>
          <div
            class="nav_tips r_right flex_a"
            :class="titleList.length == 1 ? 'r_right_no_left' : ''"
            v-if="isTabTipsRg && titleKey == 2"
          >
            <span>门店兑换，兑换完成后请前往门店自提</span>
            <Iconfont
              name="iconx"
              class="icon"
              size="0.6rem"
              color="#FD3E3E"
              @click="() => closeTip('isTabTipsRg')"
            />
          </div>
          <div
            v-for="(item, index) in titleList"
            :key="index"
            :class="titleKey == index + 1 ? 'color' : ''"
            @click="() => switchFg(index + 1)"
          >
            {{ item.name }}
            <p></p>
          </div>
        </div>

        <div class="filter flex_a">
          <div :class="sortKey == '' ? 'color' : ''" @click="() => sortFg('')">
            综合
          </div>
          <div
            :class="sortKey == 'jinbi' ? 'color flex' : 'flex'"
            @click="() => sortFg('jinbi')"
          >
            <div>积分</div>
            <div>
              <Iconfont
                name="iconarrLeft-fill"
                class="icon"
                size="0.6rem"
                :color="
                  sortKey == 'jinbi' && orderType == 'asc'
                    ? markColor
                    : '#999999'
                "
              />
              <Iconfont
                name="iconsanjiao_xia"
                class="icon"
                size="0.6rem"
                :color="
                  sortKey == 'jinbi' && orderType == 'desc'
                    ? markColor
                    : '#999999'
                "
              />
            </div>
          </div>
          <div
            :class="sortKey == 'sales' ? 'color flex' : ' flex'"
            @click="() => sortFg('sales')"
          >
            <div>兑换量</div>
            <div>
              <Iconfont
                name="iconarrLeft-fill"
                class="icon"
                size="0.6rem"
                :color="
                  sortKey == 'sales' && orderType == 'asc'
                    ? markColor
                    : '#999999'
                "
              />
              <Iconfont
                name="iconsanjiao_xia"
                class="icon"
                size="0.6rem"
                :color="
                  sortKey == 'sales' && orderType == 'desc'
                    ? markColor
                    : '#999999'
                "
              />
            </div>
          </div>
        </div>

        <!-- 商品列表 -->
        <div class="shop_list">
          <div
            class="shop_item flex_a"
            v-for="(item, index) in shopList"
            :key="index"
            @click="() => goPathUrl('/shopDetail?id=' + item.stock_id)"
          >
            <img :src="item.goods_image" alt />
            <div class="shop_main">
              <div class="shop_main_title dbellipsis">
                {{ item.goods_name }}
              </div>
              <div class="flex_b selling_price">
                <div class="price">
                  {{
                    storeInfo.is_show_retail_price == 1
                      ? "建议兑换:" + item.retail_price
                      : ""
                  }}
                </div>
                <div>已兑：{{ item.sales }}</div>
              </div>
              <div class="flex_b btn">
                <div class="btn_price flex color">
                  <div>{{ item.jinbi }}</div>
                  <div class="btn_integral borderColor">积分</div>
                </div>

                <div
                  class="exchange_btn btnColor"
                  v-if="token && item.jinbi <= b_money"
                >
                  立即兑换
                </div>
                <div v-else class="exchange_btn noshop_price">积分不足</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 没有更多数据提示 (旧模式) -->
        <!-- <div v-if="!isNoData && shopList.length > 0" class="no-more-data">
          <p>加载完了</p>
        </div> -->
        <div class="null_data_style" v-if="shopList.length==0">
        <img :src="ossImgPath+'null_new_x.png'" alt="" />
        <p>暂无商品</p>
      </div>

      </div>
      <!-- 小程序部署通知20220831 状态 0 未开始部署 1部署中。2优质用户不需部署3部署完成-->
      <div
        class="mod"
        v-if="xcxInfo.type == 0 || xcxInfo.type == 1 || xcxInfo.type == 3"
      >
        <div class="jifenpop jifenpop_xcx">
          <h4>温馨提示</h4>
          <div class="xcx_code">
            <article>{{ xcxInfo.msg }}</article>
            <img
              class="wxcode"
              v-if="xcxInfo.type == 3"
              :src="xcxInfo.wx_code"
              alt
            />
            <p>
              <a :href="'tel:' + storeInfo.phone_mob"> 联系商家 </a>
            </p>
          </div>
        </div>
      </div>
      <!-- 赚积分弹框-->
      <div class="mod" v-if="isShowPop">
        <div class="jifenpop">
          <h4>怎么赚积分</h4>
          <ul>
            <li>1.前往商家门店消费，即可获得相应积分</li>
            <li>2.积分赠送比例，请具体咨询商家</li>
            <li>
              3.关注商家促销活动，活动期间，积分多多，以商家实际宣传为准。
            </li>
          </ul>
          <button @click="konw">我知道了</button>
        </div>
      </div>

      <div v-if="erweima" class="erweima_main">
        <div class="img_main">
          <img
            src="../../images/guanbi.png"
            @click="clockFg"
            class="guanbi"
            alt
          />
          <img
            class="share_bg_img"
            :src="ossImgPath + 'share_bg_img.png'"
            alt
          />
          <div class="share_img">
            <img :src="pathList.bylm_qrcode" alt />
          </div>
          <div class="erweima_test">
            <div class="erweima_title">长按识别二维码</div>
            <div class="erweima_jr">进入社区叮咚小程序</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fraud-main" v-if="isEnterpriseInformation">
      <div class="Enterpriseaud">
        <div class="Enterpriseaud_title">店铺认证信息</div>
        <div class="Enterpriseaud_content">
          <div
            class="Enterpriseaud_content_list"
            v-if="StoreCompanyInfo.is_company == 1"
          >
            <div class="Enterpriseaud_content_list_left">店铺名称</div>
            <div class="Enterpriseaud_content_list_right">
              {{ StoreCompanyInfo.company_name }}
            </div>
          </div>
          <div class="Enterpriseaud_content_list">
            <div class="Enterpriseaud_content_list_left">负责人名称</div>
            <div class="Enterpriseaud_content_list_right">
              {{ StoreCompanyInfo.legal_name }}
            </div>
          </div>
          <div class="Enterpriseaud_content_list">
            <div class="Enterpriseaud_content_list_left">证照编号</div>
            <div class="Enterpriseaud_content_list_right">
              {{ StoreCompanyInfo.business_license }}
            </div>
          </div>
          <div class="Enterpriseaud_content_list">
            <div class="Enterpriseaud_content_list_left">认证时间</div>
            <div class="Enterpriseaud_content_list_right">
              {{ StoreCompanyInfo.created_at }}
            </div>
          </div>
        </div>
        <div class="Enterpriseaud_button" @click="closeEnterprise">关闭</div>
      </div>
    </div>
    <footer-view v-if="!demoShow && showLoading"></footer-view>
    <!-- <footerView :newMarkInfo="newMarkInfo" v-if="!demoShow && showLoading"></footerView> -->
    <div style="height: 2rem"></div>
    <div v-if="demoShow && !preview" @click="wantUseFg" class="choose_emplate">
      使用模板
    </div>
    <div class="quan_pre" v-if="demoShow && !preview"></div>
    <phoneList ref="phoneList"></phoneList>
  </div>
</template>
<script>
import footerView from "@/components/footerView.vue";
import Iconfont from "@/components/iconfont.vue";
import { sendRequest, getOpenid } from "@/assets/public";
import share from "../share.js";
import "../assets/home.css";
// import '../assets/home.scss'
import { Dialog, Toast } from "vant";
import urlconfig from "@/config.js";
import homePage from "./homePage.vue";
import mloading from "@/components/loading.vue";
import { getLocalImgData } from "weixin-js-sdk";
import phoneList from "@/components/phoneList";
export default {
  components: { footerView, Iconfont, homePage, phoneList },
  data() {
    return {
      isTabTipsRg: true, // 是否显示提示
      isTabTipsLe: true,
      isShowPop: false, //是否显示赚积分弹框
      isNoData: true, // 是否没有数据
      page: 1,
      shopList: [], // 商品数据
      isEnterpriseInformation: false, // 是否显示门店信息
      StoreCompanyInfo: "", // 门店信息
      is_showrenzheng: "", // 认证状态
      fourShopData: [], // 四条商品数据
      titleList: [{ name: "商城兑换" }, { name: "门店兑换" }],
      titleKey: 1,
      sortKey: "",
      orderType: "asc",
      isScroll: true,
      ossImgPathIndex: "",
      colorList: [
        "#FD3E3E",
        "#7141FF",
        "#FF2A62",
        "#FE6157",
        "#34C391",
        "#FFC600",
        "#282E52",
        "#25BEC9",
        "#51ADE3",
        "#333333",
        "#2C6CDC",
      ],
      mark: "",
      markColor: "",
      storeInfo: {},
      moduleList: [],
      swipeList: [],
      pathList: {},
      b_money: "", // 个人积分
      erweima: false,
      show: true,
      demoShow: false, // 模板预览
      preview: false, // 预览
      token: false, // 是否登陆
      is_show_wdd: 0,
      isFraud: false,
      xcxInfo: {},
      cate_id: "",
      isNewMode: localStorage.getItem("isNewMode"),
      showLoading: false,
      is_show_retail_price: 0,
      newMarkInfo: {},
      currentGoodsType: 0, // 默认商城兑换
      currentOrder: '', // 默认综合排序
      currentOrderType: 'asc', // 默认升序
    };
  },
  inject: ["pageRedown"],
  async created() {
    // localStorage.removeItem("isNewMode");
    if (!localStorage.getItem("ispPageRedown")) {
      localStorage.setItem("ispPageRedown", 1);
      this.pageRedown();
    }
    let id = this.$router.history.current.query.id;
    let preview = this.$router.history.current.query.preview;
    if (id == 0 || id || preview) {
      this.demoShow = true;
      if (preview) {
        this.preview = true;
      }
    }
    this.page = 1;
    this.shopList = [];
    this.isFraud = localStorage.getItem("isFraud");
    this.token = localStorage.getItem("token");
    await this.initFg();
    // this.puthListFg(); // 跳转小店爆品

    setTimeout(() => {
      this.$nextTick(() => {
        window.addEventListener("scroll", this.menu);
      });
    }, 50);
    let _this = this;

    // let scrollPosition = 0;
    // document.addEventListener('visibilitychange', function() {
    //   if (document.visibilityState === 'visible') {
    // 	_this.initFg(true);
    //     // 当页面再次变得可见时，恢复之前的滚动位置
    // 	window.addEventListener("scroll", this.menu);
    //     // window.scrollTo(0, scrollPosition);
    //   } else {
    // 	window.removeEventListener("scroll", this.menu);
    //     // 当页面变为不可见时，保存当前的滚动位置
    //     // scrollPosition = window.scrollY || window.pageYOffset;
    //   }
    // });
  },
  mounted() {
    if (localStorage.getItem("isNewMode")) {
      this.isNewMode = 1;
    } else {
      this.isNewMode = 0;
    }
    if (this.$route.query.aes) {
      sendRequest("user/getScanPayLogin", {
        store_id: this.$route.query.store_id,
        aes: this.$route.query.aes,
      }).then((e) => {
        localStorage.setItem("token", e.content.token);
        localStorage.setItem("infor", JSON.stringify(e.content));
        this.initFg();
        // window.location.reload()
      });
    } else {
      let search = window.location.href.split("?")[1]
        ? window.location.href.split("?")[1].split("code=")[1]
        : "";

      if (search && !localStorage.getItem("token")) {
        let that = this;
        getOpenid(
          search.indexOf("&") > -1 ? search.split("&")[0] : search,
          "#/login",
          window.encodeURIComponent(urlconfig.goPath),
          that.initFg
        );
      }
    }
    this.getStoreCompanyInfo();
    this.getCheckPresell(); //小程序部署
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/shopDetail") {
      from.meta.keepAlive = true;
    } else {
      let vnode = this.$vnode;
      let parentVnode = vnode && vnode.parent;
      if (
        parentVnode &&
        parentVnode.componentInstance &&
        parentVnode.componentInstance.cache
      ) {
        var key =
          vnode.key == null
            ? vnode.componentOptions.Ctor.cid +
              (vnode.componentOptions.tag
                ? `::${vnode.componentOptions.tag}`
                : "")
            : vnode.key;

        var cache = parentVnode.componentInstance.cache;
        var keys = parentVnode.componentInstance.keys;
        if (cache[key]) {
          this.$destroy();
          // remove key
          if (keys.length) {
            var index = keys.indexOf(key);
            if (index > -1) {
              keys.splice(index, 1);
            }
          }
          cache[key] = null;
        }
      }
    }
    next();
  },
  activated() {
    window.addEventListener("scroll", this.menu);
  },
  deactivated() {
    window.removeEventListener("scroll", this.menu);
  },
  methods: {
    goPhoneStore() {
      console.log(this.storeInfo, this.storeInfo.is_custorm_count);
      let is_custorm_count = this.storeInfo.is_custorm_count;
      if (is_custorm_count == 1) {
        //1个电话
        console.log("直接拨打");
      } else if (is_custorm_count > 1) {
        console.log("出弹框选择");
        this.$refs.phoneList.showPopFg();
      } else {
        // 0  商家没设置
        Toast(this.storeInfo.is_custorm_msg);
      }
    },
    // 我要使用
    wantUseFg() {
      Dialog.confirm({
        title: "提示",
        message: "确定将您的积分商城变更为此样式吗？",
      })
        .then(() => {
          sendRequest("store/setStoreMarkUsering", {
            mark_id: this.$router.history.current.query.id,
          }).then((res) => {
            if (res.status == 200) {
              Toast("修改成功");
              setTimeout(() => {
                window.dsBridge.call(
                  "jump",
                  `${urlconfig.goPath}?store_id=${localStorage.getItem(
                    "store_id"
                  )}&preview=true`
                );
              }, 1500);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    clockFg() {
      this.erweima = false;
    },
    // 商品详情
    pathSwiper(item) {
      if (this.demoShow) {
        return;
      }
      item == 1 && this.is_show_wdd == 1
        ? this.$router.push({
            path: "/appletsIndex",
          })
        : "";
    },
    // 去外链
    goWebPath(url) {
      if (this.demoShow) {
        return;
      }
      if (url == 1) {
        this.erweima = this.pathList.bylm_qrcode ? true : false;
      } else if (url) {
        window.location.href = url;
      }
    },
    puthListFg() {
      return;
      sendRequest("user/checkStoreOpening").then((res) => {
        if (res.status == 200) {
          this.pathList = res.content;
          return;
        }
      });
    },
    swiperFg() {
      // this.is_show_wdd == 1
      //   ? (this.swipeList = [
      //     { img_url: this.ossImgPathIndex + 'banner.png' },
      //     { img_url: this.ossImgPath + 'openPermissions.png' },
      //     { img_url: this.ossImgPath + 'jifen_1.png' },
      //     { img_url: 'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/h5_1banner.png' }
      //   ])
      //   : (this.swipeList = [
      //     { img_url: this.ossImgPathIndex + 'banner.png' },
      //     { img_url: this.ossImgPath + 'jifen_1.png' },
      //     { img_url: 'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/h5_1banner.png' }
      //   ])
      this.swipeList = [
        { img_url: this.ossImgPathIndex + "banner.png" },
        { img_url: this.ossImgPath + "jifen_1.png" },
        {
          img_url:
            "https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/h5_1banner.png",
        },
      ];
    },
    handScroll() {
             let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let innerHeight =
        window.innerHeight ||
        document.body.clientHeight ||
        document.documentElement.clientHeight;
      if (scrollTop + innerHeight + 200 >= document.body.scrollHeight) {
        this.isScroll = false;
        this.page = this.page + 1;

        if (this.isNewMode) {
          this.getBottomList();
        } else {
          this.initShop();
        }
      }
    },
    menu() {
      console.log(this.isScroll, "---333", this.isNoData, "====");
      if (this.isScroll) {
        // console.log('触发滚广')
        this.handScroll();
      }
    },
    // 是否显示赚积分弹框
    showJiFen() {
      if (this.demoShow) {
        return;
      }
      this.isShowPop = true;
    },
    //  获取企业信息
    async getStoreCompanyInfo() {
      let res = await sendRequest("user/getStoreCompanyInfo");
      if (res.status == 200) {
        this.is_showrenzheng = res.status;
        this.StoreCompanyInfo = res.content;
      } else {
        console.log(res);
      }
    },
    //  显示企业信息
    showEnterprise() {
      if (this.is_showrenzheng == 200) {
        this.isEnterpriseInformation = true;
      }
    },
    // 关闭企业信息
    closeEnterprise() {
      this.isEnterpriseInformation = false;
    },
    konw() {
      this.isShowPop = false;
    },
    // 关闭提示弹窗
    closeTip(e) {
      this[e] = false;
    },
    // 初始化店铺信息
    async initFg(isReach) {
      let res = await sendRequest("user/info", {
        type: 1,
      });

      if (res.status == 200) {
        this.b_money = parseInt(res.content.member.b_money);
      }
      if (isReach) {
        return;
      }
      this.storeInfoFg();
    },
    async getOldData() {
      await this.initShop(1); // 四件可兑换商品
      await this.initShop(false, 1); // 商品数据 判断商城兑换
      await this.initShop(false, 2); // 商品数据 判断本店兑换
    },
    storeInfoFg() {
      sendRequest("user/storeInfo")
        .then((result) => {
          if (result.status == 200) {
            localStorage.setItem("store_name", result.content.store.store_name);
            localStorage.setItem("store_logo", result.content.store.store_logo);
            new share();
            this.storeInfo = result.content.store;
            this.is_show_wdd = result.content.store.is_show_wdd;
            this.store_n_mark_id = result.content.store.mark_id;
            let store_mark_id = result.content.store.mark_id;

            // 2024.3.12新增模版
            if (result.content.store.mark_id >= 21) {
              localStorage.setItem("isNewMode", 1);
              this.isNewMode = 1;
              this.page = 1;
              this.shopList = [];
              this.getBottomList();
              console.log(
                JSON.parse(localStorage.getItem("mark_info")),
                "少时诵诗书所所"
              );
            } else {
              localStorage.removeItem("isNewMode");
              this.isNewMode = 0;
              this.getOldData();
            }

            console.log(
              result.content.store.mark_type,
              "znn______---------------是否显示新模板"
            );

            this.showLoading = true;
            let mark_id =
              store_mark_id <= 10 || store_mark_id > 20
                ? 3
                : store_mark_id % 10 == 0
                ? 10
                : store_mark_id % 10;
            let id = this.$router.history.current.query.id;
            console.log(id, "yulan=====");
            this.yl_mark_id = id;

            if (id == 0 || id) {
              //预览

              this.demoShow = true;
              if (id >= 21 || id == 0) {
                console.log(
                  JSON.parse(localStorage.getItem("mark_info")),
                  "-===少时诵诗书所所"
                );
                this.isNewMode = 1;
                localStorage.setItem("isNewMode", 1);
                mark_id = id;
              } else {
                this.isNewMode = 0;
                mark_id = id <= 10 || id > 20 ? 3 : id % 10 == 0 ? 10 : id % 10;
                localStorage.removeItem("isNewMode");
              }
            }
            this.ossImgPathIndex = this.ossImgPath + mark_id + "/";
            this.markColor = this.colorList[mark_id];
            this.mark = "mark" + mark_id;
            this.swiperFg();
            this.additionalFg();
            if (result.content.store.mark_type == 1) {
              this.getNewMarkList();
            }
          }
        })
        .catch((err) => {});
    },
    additionalFg() {
      sendRequest("user/moduleList")
        .then((result) => {
          if (result.status == 200) {
            this.moduleList = result.content.map((item) => {
              let img = "";
              switch (item.title) {
                case "企业商城":
                  img = this.ossImgPathIndex + "tableqy.png";
                  break;
                case "冬瓜盟":
                  img = this.ossImgPathIndex + "tableDgm.png";
                  break;
                case "冬瓜街":
                  img = this.ossImgPathIndex + "tableDgj.png";
                  break;
                case "大转盘":
                  img = this.ossImgPathIndex + "tableDzp.png";
                  break;
              }
              return { ...item, img };
            });
          }
        })
        .catch((err) => {});
    },

    // 切换
    switchFg(e) {
      if (this.demoShow) {
        return;
      }
      this.titleKey = e;
      this.sortKey = "";
      this.page = 1;
      this.isNoData = true;
      this.initShop();
    },
    // 切换排序
    sortFg(e) {
      if (this.demoShow) {
        return;
      }
      if (this.sortKey == e) {
        this.orderType = this.orderType == "asc" ? "desc" : "asc";
      } else {
        this.orderType = "asc";
      }
      this.sortKey = e;
      this.page = 1;
      this.isNoData = true;
      this.initShop();
    },
    refresh(id) {
      this.cate_id = id;
      this.page = 1;
      this.shopList = [];
      this.isNoData = true;
      this.getBottomList();
      // this.initShop(false,'0');
    },
    getBottomList() {  //列表
      console.log(this.goods_type,this.order,this.order_type,'ppppppp====')
      sendRequest("goods/index_list", {
        page: this.page,
        limit: 10, // 或者你index.vue里管理的分页limit
        cate_id: this.cate_id, // 确保这个 cate_id 是 index.vue 中当前分类的ID
        goods_type: this.goods_type,
        order: this.order,
        order_type: this.order_type,

      })
      .then((result) => {
        setTimeout(() => {
          this.isScroll = true;
        }, 200);

        if (result.status == 200) {
          this.is_show_retail_price = result.content.is_show_retail_price;
          this.shopList =[...this.shopList, ...result.content.list]
            // this.page == 1
            //   ? result.content.list
            //   : [...this.shopList, ...result.content.list];
          if (
            result.content.list.length == 0 ||
            this.shopList.length == result.content.count
          ) {
            console.log( this.shopList.length == result.content.count,'2222')
            this.isNoData = false;
          }
        }
      })
      .catch((error) => {
        console.error("获取列表失败:", error);
      });
    },
    // 初始化店铺 商品 首次进入要进行判断商城兑换和门店兑换是否存在商品
    initShop(key, once) {
      sendRequest("goods/list", {
        limit: key ? 4 : 20,
        page: this.page,
        convertible: key, // 是否推荐
        convertible_list: key ? 0 : 0,
        goods_type: key ? 0 : once ? once : this.titleKey,
        order: key ? "" : this.sortKey,
        order_type: key ? "" : this.orderType,
        cate_id: this.cate_id,
      })
        .then((result) => {
          setTimeout(() => {
            this.isScroll = true;
          }, 200);
          if (result.status == 200) {
            if (once == 2) {
              if (
                result.content.list.length == 0 &&
                this.titleList.length != 1
              ) {
                this.titleList = [this.titleList[0]];
              }
              return;
            }
            if (
              once == 1 &&
              result.content.list.length == 0 &&
              this.titleList.length != 1
            ) {
              this.titleList = [this.titleList[1]];
            }
            if (key) {
              this.fourShopData = result.content.list;
            } else {
              this.shopList =
                this.page == 1
                  ? result.content.list
                  : [...this.shopList, ...result.content.list];
              if (result.content.list.length == 0) {
                this.isNoData = false;
              }
            }
          }
        })
        .catch((err) => {});
    },
    goPathUrl(e, key) {
      if (this.demoShow) {
        return;
      }
      if (key != "web" && key && !localStorage.getItem("token")) {
        this.Dialog.confirm({
          message: "请先登录",
          confirmButtonText: "登录",
        }).then(() => {
          if (this.isWexinLogin) {
            var appid = "wxcef271c70c3c8428"; // appid
            var url = window.encodeURIComponent(urlconfig.goPath); // 回调链接地址，需转码为URI格式，必须去除#后的参数
            var scope = "snsapi_base"; // snsapi_base静默授权，snsapi_userinfo弹出授权页面
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`;
          } else {
            this.$router.push("/login");
          }
        });
      } else if (key == "web") {
        window.location.href = e;
      } else {
        this.$router.push({
          path: e,
        });
      }
    },
    overFraudFg() {
      this.isFraud = false;
      localStorage.removeItem("isFraud");
    },
    //小程序部署
    getCheckPresell() {
      sendRequest("user/checkPresell").then((res) => {
        if (res.status == 200) {
          this.xcxInfo = res.content.store;
          return;
        }
      });
    },

    //新模板底部
    getNewMarkList() {
      sendRequest("store/getStoreMarkList", {
        mark_id: this.yl_mark_id,
      }).then((ress) => {
        if (ress.status == 200) {
          var array = ress.content;
          array.forEach((item) => {
            if (item.isusing == 1) {
              this.newMarkInfo = item;
            }
          });
        }

        console.log(ress, "wwwww---首页");
      });
    },
    // 处理 homePage 触发的排序/tab切换事件
    handleSortChange({ goods_type, order, order_type,isfasle }) {
      this.goods_type=goods_type
      this.order=order
      this.order_type=order_type
       this.shopList=[]
      this.page=1,
      // this.isScroll=isfasle
      this.getBottomList()
      console.log("收到homePage的排序/tab切换事件:", { goods_type, order, order_type,isfasle });
     
    },
  },
};
</script>
<style scoped>
.quan_pre {
  width: 100%;
  height: 100%;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 990;
}

img[src=""],
img:not([src]) {
  opacity: 0;
}

.jifenpop {
  width: 12.44rem;
  height: 9.68rem;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.2rem;
}

.jifenpop h4 {
  color: #333333;
  font-size: 0.68rem;
  text-align: center;
}

.jifenpop ul {
  padding: 0 0.68rem;
}

.jifenpop li {
  line-height: 1rem;
  color: #666666;
  font-size: 0.56rem;
}

.jifenpop button {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 12.44rem;
  height: 2.08rem;
  border-top: 0.0625rem solid #ddd;
  text-align: center;
  color: #fd3e3e;
  font-size: 0.68rem;
}

.home {
  background: #ffffff;
  padding-bottom: 0.4rem;
}

.home_top {
  width: 15rem;
  height: 8.6rem;
  position: relative;
}

.topbg {
  width: 15rem;
}

.home_title {
  width: 15rem;
  height: 6rem;
  position: absolute;
  top: 0;
  left: 0;
}

.name {
  width: 10rem;
  text-overflow: ellipsis;
  line-height: 1.32rem;
  height: 1.32rem;
  overflow: hidden;
  white-space: nowrap;
}

.home_title .title {
  margin-top: 0.72rem;
  font-size: 0.68rem;
  /*font-weight: 600;*/
  color: rgba(255, 255, 255, 1);
}

.title img {
  width: 1.32rem;
  height: 1.32rem;
  margin: 0 0.6rem;
  border-radius: 50%;
}

.search {
  width: 1.24rem;
  height: 1.24rem;
  line-height: 1.24rem;
  border-radius: 50%;
  margin-right: 0.6rem;
  margin-top: 0.72rem;
  background: rgba(0, 0, 0, 0.1);
  text-align: center;
}

.search .icon {
  line-height: 1.24rem;
  display: block;
}

.home_swiper {
  position: absolute;
  bottom: 0rem;
  left: 0.4rem;
  width: 14.2rem;
  height: 6rem;
  border-radius: 0.4rem;
}

.home_swiper img {
  width: 14.2rem;
  height: 6rem;
  border-radius: 0.4rem;
  display: block;
}

.table_swiper {
  padding: 0.4rem;
}

.nut-swiper-slide {
  display: block;
}

.nut-swiper-slide {
  width: 100%;
  height: 4rem;
}

.tablist {
  width: 100%;
  height: 2.7rem;
}

.tablist img {
  width: 2.7rem;
  height: 2.7rem;
  display: block;
  border: none;
}

.my_scores {
  width: 14.2rem;
  height: 1.6rem;
  margin: 0.6rem auto;
  border-radius: 0.8rem;
  line-height: 1.6rem;
}

.my_scores > .iconfont {
  float: left;
  width: 0.72rem;
  height: 0.72rem;
  margin: 0 0.2rem 0.44rem 0.3rem;
}

.my_scores .title {
  float: left;
  font-size: 0.64rem;
  margin: 0.5rem 0;
  line-height: 0.6rem;
  padding-right: 0.4rem;
  border-right: 0.0625rem solid #000;
}

.my_scores .init {
  font-weight: bolder;
  font-size: 0.6rem;
  line-height: 1.6rem;
  padding-left: 0.4rem;
  float: left;
}

.my_scores span {
  float: right;
  line-height: 1.6rem;
  padding-right: 0.4rem;
  font-size: 0.6rem;
}

.recommend {
  width: 14.2rem;
  height: 7.2rem;
  margin: 0 0.4rem;
  position: relative;
}

.recommend .com_bg_img {
  width: 14.2rem;
  height: 7.2rem;
}

.recommend_title {
  position: absolute;
  top: 0.4rem;
  left: 0;
  width: 14.2rem;
  overflow: hidden;
}

.recommend_title img {
  width: 4.8rem;
  height: 1.64rem;
  margin-left: 0.26rem;
}

.recommend_title p {
  width: 3.2rem;
  height: 0.96rem;
  background: #fff;
  text-align: center;
  line-height: 0.96rem;
  border-radius: 0.48rem;
  margin-right: 0.4rem;
  margin-top: 0.26rem;
  font-size: 0.48rem;
}

.recommend_list {
  position: absolute;
  top: 2.66rem;
  left: 0;
  display: flex;
  width: 14rem;
  padding: 0 0.1rem;
  justify-content: space-around;
}

.recommend_list div {
  text-align: center;
  font-size: 0.48rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}

.recommend_list div img {
  width: 2.8rem;
  height: 2.8rem;
  padding: 0.2rem;
  background: #fff;
  border-radius: 0.3rem;
  display: block;
  margin-bottom: 0.46rem;
}

/*//跳转列表*/
.path_list {
  width: 14.2rem;
  height: 3.2rem;
  display: flex;
  justify-content: space-around;
  margin: 0.6rem auto 0;
}

.path_list img {
  width: 4.46rem;
  height: 3.2rem;
  display: block;
}

.redemption_list {
  padding-bottom: 2.2rem;
}

.redemption_list .redemption_tab {
  width: 15rem;
  height: 1.8rem;
  line-height: 1.8rem;
  font-size: 0.6rem;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  border-bottom: 0.0625rem solid #eeeeee;
  margin: 0 auto;
  position: relative;
  background: #fff;
}

.redemption_tab .nav_tips {
  height: 1.16rem;
  background: #fff1f1;
  color: #fd3e3e;
  font-size: 0.48rem;
  line-height: 1.16rem;
  border-radius: 1.5625rem;
  padding: 0 0.4rem;
  z-index: 1;
}

.redemption_tab .icon {
  margin-top: 0.4rem;
  margin-left: 0.2rem;
}

.l_left {
  position: absolute;
  bottom: -1.7rem;
  left: 0.8rem;
}

.l_left_no_right {
  left: 4rem;
}

.r_right {
  position: absolute;
  bottom: -1.7rem;
  right: 1rem;
}

.r_right_no_left {
  right: 4rem;
}

.r_right:after {
  content: "";
  position: absolute;
  top: -0.2rem;
  right: 2.6rem;
  width: 0.4rem;
  height: 0.4rem;
  background: #fff1f1;
  transform: rotate(-45deg);
}

.redemption_tab .l_left:after {
  content: "";
  position: absolute;
  top: -0.2rem;
  left: 2.6rem;
  width: 0.4rem;
  height: 0.4rem;
  background: #fff1f1;
  transform: rotate(-45deg);
}

.redemption_tab .active {
  position: relative;
}

.redemption_tab .active p {
}

.redemption_tab div p {
  height: 0.12rem;
  width: 1.2rem;
  margin: 0 auto;
}

.filter {
  height: 1.68rem;
  line-height: 1.68rem;
  font-size: 0.52rem;
  font-family: PingFang SC;
  font-weight: 500;
  background: #fff;
  color: rgba(153, 153, 153, 1);
}

.filter .active {
}

.icon {
  line-height: 0.3rem;
  display: block;
}

.iconarrLeft-fill {
  position: relative;
  top: 0.6rem;
}

.iconsanjiao_xia {
  position: relative;
  top: 0.6rem;
}

.shop_list {
  background: #f5f5f5;
  overflow: hidden;
  padding-bottom: 0.4rem;
}

.shop_item {
  height: 4.8rem;
  width: 14.2rem;
  margin: 0.4rem auto 0;
  box-sizing: border-box;
  padding: 0.4rem;
  background: #fff;
  border-radius: 0.2rem;
}

.shop_item img {
  width: 4rem;
  height: 4rem;
  display: block;
}

.shop_main {
  width: 8.8rem;
}

.shop_main_title {
  font-size: 0.6rem;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  /* height: 1.3rem; */
  /* line-height: 0.65rem; */
}

.selling_price {
  font-size: 0.48rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.48rem;
  margin-top: 0.4rem;
}

/* .selling_price .price {
  text-decoration: line-through;
} */

.btn {
  margin-top: 0.48rem;
}

.btn .btn_price {
  font-size: 0.72rem;
  font-family: PingFang SC;
  font-weight: bold;
}

.btn .btn_integral {
  width: 1.4rem;
  height: 0.56rem;
  border-radius: 0.28rem;
  text-align: center;
  line-height: 0.56rem;
  font-size: 0.4rem;
  margin-top: 0.15rem;
  margin-left: 0.08rem;
  border: 0.0625rem solid #ccc;
}

.exchange_btn {
  width: 3rem;
  height: 0.96rem;
  border-radius: 0.48rem;
  text-align: center;
  line-height: 0.96rem;
  color: #fff;
  font-size: 0.48rem;
}

.erweima_main {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 88;
}

.guanbi {
  width: 1.04rem;
  height: 1.04rem;
  display: block;
  position: absolute;
  right: 0;
  top: -1.5rem;
}

.erweima_main .img_main {
  width: 12.4rem;
  height: 15rem;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.36rem;
}

.share_bg_img {
  display: block;
  width: 100%;
  height: 7.56rem;
  position: absolute;
  top: 0;
  left: 0;
}

.share_img {
  width: 9.2rem;
  height: 9.2rem;
  border-radius: 0.2rem;
  box-shadow: 0rem 0.2rem 0.6rem 0rem rgba(0, 0, 0, 0.06);
  background: #fff;
  border: 0.6rem solid #fff;
  box-sizing: border-box;
  display: block;
  margin: 1.6rem auto 0;
  position: relative;
}

.share_img img {
  width: 100%;
  height: 100%;
  display: block;
}

.erweima_test {
  position: absolute;
  bottom: 1.2rem;
  width: 100%;
  text-align: center;
}

.erweima_title {
  font: size 0.72rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 0.55rem;
}

.erweima_jr {
  font-size: 0.6rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.choose_emplate {
  width: 13.6rem;
  height: 1.36rem;
  line-height: 1.36rem;
  text-align: center;
  color: #fff;
  background: #fd7128;
  border-radius: 34rpx;
  border-radius: 25px;
  margin: 0 auto;
  position: fixed;
  bottom: 1rem;
  left: 0.7rem;
  z-index: 11111;
}
</style>

<style>
.my-swipe {
  border-radius: 0.4rem;
}

.my-swipe .van-swipe-item {
  text-align: center;
}

.my-swipe img {
  width: 14.2rem;
}

.van-swipe {
  top: 0;
}

.van-swipe__track {
  width: 100%;
}

.table_swiper .van-swipe__indicator:not(:last-child) {
  margin-right: 0;
}

.table_swiper .van-swipe__indicator {
  width: 0.48rem;
  height: 0.16rem;
}

.table_swiper .van-swipe__indicators {
  background: #eeeeee;
  bottom: 0;
}

.noshop_price {
  background: #dddddd;
}

.fraud-main {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.7);
}

.fraud {
  width: 13.6rem;
  padding: 1.04rem 1.34rem 1.24rem;
  box-sizing: border-box;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.fraud-title {
  font-size: 0.84rem;
  font-weight: 500;
  color: #f11818;
  line-height: 1.2rem;
  text-align: center;
  padding-bottom: 0.66rem;
  border-bottom: 0.0625rem solid #f11818;
}

.fraud-size {
  padding: 0 0.6rem;
  font-size: 0.6rem;
  font-weight: 500;
  color: #333333;
  line-height: 1.2rem;
}

.fraud-main-title {
  font-size: 0.68rem;
  font-weight: 500;
  color: #333333;
  line-height: 0.96rem;
  margin-top: 0.6rem;
  margin-bottom: 0.36rem;
  text-align: center;
}

.text-right {
  text-align: right;
}

.compon {
  margin-top: 0.56rem;
}

.fraud-btn {
  width: 10.6rem;
  height: 1.6rem;
  background: #ee0a24;
  border-radius: 4rem;
  margin: 1.2rem auto 0;
  text-align: center;
  line-height: 1.6rem;

  font-size: 0.56rem;
  font-weight: 400;
  color: #ffffff;
}

.Enterpriseaud {
  width: 12.44rem;
  padding: 1.16rem 0.8rem 0.6rem 0.8rem;
  background: #ffffff;
  border-radius: 0.64rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.Enterpriseaud_title {
  text-align: center;
  font-size: 0.64rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #323233;
  line-height: 0.88rem;
  padding-bottom: 0.7rem;
}

.Enterpriseaud_content_list {
  width: 100%;
  display: flex;
  padding: 0.48rem 0;
}

.Enterpriseaud_content_list_left {
  width: 4rem;
  text-align: left;
  font-size: 0.6rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #999999;
  line-height: 0.8rem;
}

.Enterpriseaud_content_list_right {
  flex: 1;
  text-align: right;
  font-size: 0.6rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.8rem;
}

.Enterpriseaud_button {
  width: 10.52rem;
  height: 1.44rem;
  background: #ee0a24;
  border-radius: 0.72rem;
  margin: 0 auto;
  margin-top: 0.6rem;
  text-align: center;
  font-size: 0.6rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 1.44rem;
}

.title .B_renzheng {
  width: 0.52rem !important;
  height: 0.52rem !important;
  position: absolute;
  left: 1rem;
  top: 1.5rem;
}

.wxcode {
  width: 6rem;
  height: 6rem;
  margin: 0 auto;
}

.xcx_code {
  text-align: center;
  font-size: 0.56rem;
  color: #333;
  /* padding: 0 0.4rem; */
}

.xcx_code article {
  padding: 0 0.4rem;
  padding-bottom: 0.4rem;
}

.jifenpop_xcx {
  height: auto !important;
}

.xcx_code p {
  line-height: 2rem;
  border-top: 1px solid #eee;
  color: #f00;
  margin-top: 0.4rem;
}

.xcx_code p a {
  color: #f00;
}
.pr {
  position: relative;
}
.phone_tel_x {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background: transparent;
}
.null_data_style{
		text-align: center;
		color: #969799;
		font-size: 0.56rem;
    padding-bottom: 3rem;
	}
 .null_data_style img{
  width: 30%;
 } 
</style>
